import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';

export default function EddiTable(props) {
  const { regionData, monyr, areaType } = props;
  const { levelColors } = useContext(ColorsContext);
  
  let droughtRegions = [
    "Western",
    "Connecticut River",
    "Central",
    "Northeast",
    "Southeast",
    "Cape Cod",
    "Islands"
  ];

  const basins = [
    "Blackstone",
    "Boston Harbor",
    "Buzzards Bay",
    "Cape Cod",
    "Charles",
    "Chicopee",
    "Connecticut",
    "Deerfield",
    "Farmington",
    "French",
    "Housatonic",
    "Hudson",
    "Ipswich",
    "Islands",
    "Merrimack",
    "Millers",
    "Narragansett Bay",
    "Nashua",
    "North Coastal",
    "Parker",
    "Quinebaug",
    "Shawsheen",
    "South Coastal",
    "SuAsCo",
    "Taunton",
    "Ten Mile",
    "Westfield"
  ];

  const droughtAreas = areaType === 'region' ? droughtRegions : basins;

  return (
    <>
      <table className="pcpnTable-container">
        <caption>
          {"2-Month EDDI Summary for"} {monyr} 
        </caption>
        <thead>
          <tr>
              <td colSpan="2">
                  <table className="tableLegend-container">
                      <tbody>
                          <tr>
                              <td className="tableLegend-heading" colSpan="5">Shading indicates index severity level:</td>
                          </tr>
                          <tr>
                              <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>Level 0</td>
                              <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>Level 1</td>
                              <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>Level 2</td>
                              <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>Level 3</td>
                              <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>Level 4</td>
                          </tr>
                      </tbody>
                  </table>
              </td>
          </tr>
          <tr>
            <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
            <th scope="col" abbr="Median">{"Median of individual grid cell values (percentile)"}</th>
          </tr>
        </thead>
        <tbody>
          {droughtAreas.map((rd, i) => (
            <tr key={i}>
              <th scope="row">{rd.replace("Connecticut River","CTRV")}</th>
              <td 
                style={{
                  backgroundColor: levelColors[regionData[rd]["02mn_level"]], 
                  color: regionData[rd]["02mn_level"] !== 4 ? "black" : "white"
                }}
              >
                {regionData[rd]["02mn_pctl"] !== -999 ? regionData[rd]["02mn_pctl"] : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}